import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navigation", "backdrop", "navbar"]

  declare readonly navigationTarget: HTMLElement
  declare readonly backdropTarget: HTMLElement
  declare readonly navbarTarget: HTMLElement

  openMenu(event: Event) {
    this.backdropTarget.classList.remove("backdropOut")
    this.navbarTarget.classList.remove("navbarOut")
    this.navigationTarget.classList.remove("hidden")
    this.backdropTarget.classList.add("backdrop")
    this.navbarTarget.classList.add("navbar")
  }

  closeMenu(event: Event) {
    this.navbarTarget.addEventListener(
      "animationend",
      () => {
        this.navigationTarget.classList.add("hidden")
      },
      { once: true }
    )

    this.backdropTarget.classList.remove("backdrop")
    this.navbarTarget.classList.remove("navbar")
    this.backdropTarget.classList.add("backdropOut")
    this.navbarTarget.classList.add("navbarOut")
  }
}
